import ast from './ast';
import { common } from '@tencent/ceiba-base-components';
import CDialog from '@tencent/ceiba-base-components/src/components/base-dialog';
import constData from './config';
import Vue from 'vue';

export default {
  components: { [CDialog.name]: CDialog },
  initBbTopbar(meta) {
    if (document.getElementsByClassName("downloadbar").length > 0) {
      // 判断是否插入过样式，避免重复插入
      console.log('BB download bar has already inserted');
      return;
    }
    const isCloseBBfootBar = common.tool.getQueryparams('closeBBFootBar');
    const isCloseTgclubTopBar = common.tool.getQueryparams('closeTgclubTopBar');

    console.log('initBbTopbar======================meta=', meta);
    console.log('initBbTopbar======================closeBBtb=', isCloseBBfootBar);
    console.log('initBbTopbar======================closeTGCLUBtb=', isCloseTgclubTopBar);
    if (ast.isAPP() || isCloseBBfootBar) {
      console.log('loadScript');
      return;
      // common.tool.loadScript("bbfooter", "//bb.img.qq.com/bbcdn/act/dnf/downloadBanner/banner.js", callback())
    }
    const bannerParamsDL = {
      position: 'bottom',                        // iframe位置，默认底部
      attrClass: 'down-iframe',                  // iframe标签和外层div的class属性
      attrName: 'DBFrame',                       // iframe的name属性
      scale: 0.14,                               // 宽高比，默认w/h=0.2
      page: '/act/dnf/downloadBanner/index',     // 加载页面
      background: '#000000',                     // 背景色
      color: '#FFFFFF',                          // 文字颜色
      opacity: 1,                                // 透明度（1-不透明，0-透明）
      isAPG: false,                              // 是否在APG中使用
    };
    const gameInfoDL = {
      openNative: '0',        // 拉起后是否打开原生页面，false为打开web页面
      openNativeParams: {},   // 拉起原生页面用到的参数，由客户端提供
      gameId: '10014',        // 助手gameId
      icon: '',               // 显示图标
      title: '',              // 显示标题
      context: '',            // 显示文案
      winWidth: 0,            // 屏幕宽度
      action: 20002,
      system: 'Android',      // 指定系统
      channelId: 1,
      jumpToUrl: '',          // 跳转链接（不带参）
      urlParams: '',          // 跳转页面携带参数
      reportId: '',           // 埋点ID（客态页无法传递用户态）
      reportGame: '',         // 埋点对应游戏业务
      pageDomain: 'qq.com',   // common.js会将父页面域设置为"qq.com",会产生跨域问题
      argEx: '0',             // 是否扩展拉起参数，暂时只发现CFM、DNF需要
      isGameHelper: '0',      // 是否是大通版（腾讯游戏助手）打开的页面
    };
    const bannerDL = {
      iframeW: 0,
      iframeH: 0,
      style: '.%styleClass%{width:%iframeW%px;height:%iframeH%px;position:fixed;%position%:0;left:0;z-index:999;overflow:hidden;opacity:%opacity%}',
      html: '<iframe class="downloadbar %styleClass%" id="%iFrameName%" src="%src%" allowtransparency="true" frameborder="0" name="%iFrameName%"></iframe>',
      accMul(s1, s2) {
        let m = 0;
        s1 = s1.toString();
        s2 = s2.toString();
        try {
          m += s1.split('.')[1].length;
        } catch (e) {
        }
        try {
          m += s2.split('.')[1].length;
        } catch (e) {
        }
        return Number(s1.replace('.', '')) * Number(s2.replace('.', '')) / Math.pow(10, m);
      },
      accDiv(arg1, arg2) {
        let t1 = 0;
        let t2 = 0;
        try {
          t1 = arg1.toString().split('.')[1].length;
        } catch (e) {
        }
        try {
          t2 = arg2.toString().split('.')[1].length;
        } catch (e) {
        }
        const r1 = Number(arg1.toString().replace('.', ''));
        const r2 = Number(arg2.toString().replace('.', ''));
        return this.accMul((r1 / r2), Math.pow(10, t2 - t1));
      },
      iframeWidth() {
        // 浏览器的兼容
        return window.innerWidth || document.documentElement.clientWidth;
      },
      iframeHeight(scale) {
        const w = this.iframeW < 320 ? 420 : this.iframeW;
        return Math.round(this.accMul(w, scale));
      },
      setIFrame(ginfo, params = {}) {
        bannerParamsDL.page = `//${location.host}${bannerParamsDL.page}`;
        for (const p in params) {
          if (bannerParamsDL[p] === undefined) {
            throw `setIFrame args[0] : ${p} is redundant params`;
          } else if (params[p] !== '' && params[p] !== null && typeof params[p] !== 'object') {
            if (p === 'scale' && params[p] > 0.5) {
              params[p] = 0.18;
            }
            bannerParamsDL[p] = params[p];
          }
        }
        // ginfo.jumpToUrl = ginfo.jumpToUrl.replace('&', '?@?').replace('%26', '%3F%40%3F');
        for (const g in ginfo) {
          if (gameInfoDL[g] === undefined) {
            throw `setIFrame args[1] : ${g} is redundant params`;
          } else if (ginfo[g] !== '' && ginfo[g] !== null && typeof ginfo[g] !== 'object') {
            gameInfoDL[g] = ginfo[g];
          }
        }
        gameInfoDL.urlParams = gameInfoDL.urlParams === '' ? '' : btoa(gameInfoDL.urlParams);
        gameInfoDL.bg = bannerParamsDL.background;      // comFun.getUrlParam会把background过滤掉
        gameInfoDL.color = bannerParamsDL.color;
        gameInfoDL.opacity = bannerParamsDL.opacity;
        gameInfoDL.pageDomain === '' ? '' : document.domain = gameInfoDL.pageDomain;
        console.log('gameInfoDL:', gameInfoDL);
        this.createBanner();
        return;
      },
      makeUrl() {
        const url = bannerParamsDL.page;
        if (gameInfoDL.winWidth === 0 || gameInfoDL.winWidth === undefined) {
          // gameInfoDL.winWidth = this.iframeWidth();
          gameInfoDL.winWidth = '0';
        }
        gameInfoDL.scale = bannerParamsDL.scale;
        // 获取系统
        const agent = navigator.userAgent;
        if (agent.indexOf('iPhone') >= 0) {
          gameInfoDL.system = 'iPhone';
        } else if (agent.indexOf('Android') >= 0) {
          gameInfoDL.system = 'android';
        }
        let urlParams = [];
        for (const g in gameInfoDL) {
          if (gameInfoDL[g] !== undefined && gameInfoDL[g] !== null && gameInfoDL[g] !== '') {
            urlParams.push(`${g}=${gameInfoDL[g]}`);
          }
        }
        urlParams = urlParams.join('&');
        console.log(`${url}?${urlParams}`);
        return `${url}?${urlParams}`;
      },
      createBanner() {
        this.iframeW = this.iframeWidth();
        this.iframeH = this.iframeHeight(bannerParamsDL.scale);
        if (bannerParamsDL.position !== 'top' && bannerParamsDL.position !== 'bottom') {
          throw `args[0]: "${bannerParamsDL.position}" error`;
        }
        const head = document.head || document.getElementsByTagName('head')[0];
        const body = document.body || document.getElementsByTagName('body')[0];
        const html = this.html.replace('%styleClass%', bannerParamsDL.attrClass).replace(/%iFrameName%/g, bannerParamsDL.attrName)
          .replace('%src%', this.makeUrl());
        const style = this.style.replace('%styleClass%', bannerParamsDL.attrClass).replace('%iframeW%', this.iframeW)
          .replace('%iframeH%', this.iframeH)
          .replace('%position%', bannerParamsDL.position)
          .replace('%opacity%', bannerParamsDL.opacity);
        const styleNode = document.createElement('style');
        const iframeDiv = document.createElement('div');
        const scripts = document.body.getElementsByTagName('script');
        const first = document.body.firstChild;

        // 增加iframe窗口，并用div节点包裹
        iframeDiv.setAttribute('class', bannerParamsDL.attrClass);
        iframeDiv.innerHTML = html;
        if (!bannerParamsDL.isAPG) {
          // 避免添加到body中script标签之后
          try {
            body.insertBefore(iframeDiv, scripts[0]);
          } catch (error) {
            if (scripts.length > 1) {
              body.insertBefore(iframeDiv, scripts[1]);
            } else {
              throw 'scripts[0] is not a child of body';
            }
          }
        } else {
          // 兼容APG直接生成的代码（div嵌套script标签）,直接添加到body头部位置
          body.insertBefore(iframeDiv, first);
        }

        // 增加style节点
        styleNode.appendChild(document.createTextNode(style));
        head.appendChild(styleNode);
        return;
      },
      // 重载iframe宽高
      resize() {
        const iFrameId = bannerParamsDL.attrName;
        this.iframeW = this.iframeWidth();
        this.iframeH = this.iframeHeight(bannerParamsDL.scale);
        const iFrameDOM = document.getElementById(iFrameId);
        iFrameDOM.style.width = `${this.iframeW}px`;
        iFrameDOM.style.height = `${this.iframeH}px`;
      },
    };
    let url;
    let action;
    const argEx = '1';
    console.log('Vue.prototype?.$storeInstance', Vue.prototype.$actInfo);
    const gid = Vue.prototype.$actInfo?.gid;
    const gameId = constData?.GAMEINFO[gid]?.gameId || 10014;
    const subGameId = constData?.GAMEINFO[gid]?.subGameId || 10014;
    const winUrl = window.location.href;
    const regex = /^(.*?)\?([\s\S]*)gameId=\d+&?(.*)$/gm;
    const match = regex.exec(winUrl);
    let newUrl = '';
    if (!match) {
      newUrl = `${window.location.href}?subGameId=${subGameId}`;
    } else {
      newUrl = `${match[1]}?${match[2]}${match[3]}&subGameId=${subGameId}`;
    }
    const actUrl = newUrl; // 修改由于过度转义引起的拉起异常(跳转到未知页面)
    console.log('footer---------------actUrl', actUrl);
    if (navigator.userAgent.indexOf('iPhone') >= 0) {
      action = common.tool.getQueryparams('action') || 20002;
      url = actUrl;
    } else {
      action = common.tool.getQueryparams('action') || 20003;
      // jumpUrl中转时，会将cf/NewYear转换成cfewYear
      if (parseInt(subGameId, 10) === 20006 || parseInt(subGameId, 10) === 20003) {
        url = actUrl;
      } else {
        url = `http://mwegame.qq.com/act/jumpUrl?acturl=${actUrl}`;
      }
    }
    console.log('footer---------------', gameId, subGameId, actUrl);
    const ginfo = {
      title: constData?.GAMEINFO[gid]?.title || constData?.GAMEINFO[subGameId]?.title || 'DNF助手',
      argEx,
      gameId,
      jumpToUrl: url,
      winWidth: window.innerWidth || document.documentElement.clientWidth,
      action,
    };
    console.log('bannerDL done', ginfo);
    // 后续要用downloadBanner/index来处理拉起
    bannerDL.setIFrame(ginfo, { page: 'https://mwegame.qq.com/act/dnf/downloadBanner/index' });
    window.onresize = function () {
      bannerDL.resize();
    };
  },
};
